import { call, put, takeEvery } from 'redux-saga/effects';
import { getRequest, postRequest, putRequest } from '../../network';
import {
    getProfileDashboards,
    createProfileDashboard,
    updateProfileDashboard
} from '../apis';
import {
    fetchPersonalityArchetypesStart,
    fetchPersonalityArchetypesSuccess,
    fetchPersonalityArchetypesFail,
    createPersonalityArchetypeStart,
    createPersonalityArchetypeSuccess,
    createPersonalityArchetypeFail,
    updatePersonalityArchetypeStart,
    updatePersonalityArchetypeSuccess,
    updatePersonalityArchetypeFail
} from '../slices/personalityArchetypesSlice';

function* personalityArchetypesApiSaga(action) {
    const {
        endpoint,
        method = 'get',
        successAction,
        failAction,
        payload = null,
        callback = null
    } = action.payload;
    const requestFunction = method === 'post' ? postRequest : method === 'put' ? putRequest : getRequest;

    try {
        const response = yield call(requestFunction, endpoint, payload);
        if (callback && typeof callback === 'function') {
            yield call(callback, true);
        }
        yield put(successAction(response));
    } catch (error) {
        if (callback && typeof callback === 'function') {
            let errorMessage = 'Something went wrong';
            if (error.response?.data?.message && error.response?.data?.errors) {
                errorMessage = `${error.response.data.message}: ${error.response.data.errors.join(', ')}`;
            } else if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            yield call(callback, false, errorMessage);
        }
        yield put(failAction(error.message));
    }
}

function* fetchPersonalityArchetypesSaga(action) {
    yield personalityArchetypesApiSaga({
        payload: {
            endpoint: getProfileDashboards,
            payload: action.payload,
            successAction: fetchPersonalityArchetypesSuccess,
            failAction: fetchPersonalityArchetypesFail
        }
    });
}

function* createPersonalityArchetypeSaga(action) {
    yield personalityArchetypesApiSaga({
        payload: {
            endpoint: createProfileDashboard,
            method: 'post',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: createPersonalityArchetypeSuccess,
            failAction: createPersonalityArchetypeFail
        }
    });
}

function* updatePersonalityArchetypeSaga(action) {
    yield personalityArchetypesApiSaga({
        payload: {
            endpoint: updateProfileDashboard.replace(':id', action.payload.id),
            method: 'put',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: updatePersonalityArchetypeSuccess,
            failAction: updatePersonalityArchetypeFail
        }
    });
}

export function* watchPersonalityArchetypes() {
    yield takeEvery(fetchPersonalityArchetypesStart.type, fetchPersonalityArchetypesSaga);
    yield takeEvery(createPersonalityArchetypeStart.type, createPersonalityArchetypeSaga);
    yield takeEvery(updatePersonalityArchetypeStart.type, updatePersonalityArchetypeSaga);
}
